export default __webpack_public_path__ + "static/media/requirements.91c22c9c.svg";